 <template>
  <v-dialog v-model="dialog" max-width="750" persistent>
    <v-card class="pt-2 pl-0 pr-0">
      <v-card-title
        class="headline-6"
        :class="{ 'subtitle-2': $vuetify.breakpoint.xs }"
        style="word-break: normal; !important"
      >
        {{
          lnb && !lnb.id
            ? $vuetify.lang.t("$vuetify.NOVO_LNB")
            : $vuetify.lang.t("$vuetify.ATUALIZANDO_LNB")
        }}
      </v-card-title>

      <v-form ref="form" lazy-validation>
        <v-row class="ma-0 d-flex justify-center mb-n3">
          <v-col cols="3" class="ml-n2 mr-6">
            <v-row>
              <span
                class="text-right subtitle-2 font-weight-bold grey--text text--lighten-1"
              >
                {{ $vuetify.lang.t("$vuetify.NOME") }}:</span
              >
            </v-row>
            <v-row md="2">
              <v-text-field
                v-model.trim="lnb.nome"
                dense
                single-line
                solo
                max-width="200"
                :rules="rules"
              ></v-text-field>
            </v-row>
          </v-col>

          <v-col cols="4" class="mr-6">
            <v-row>
              <span
                class="text-right subtitle-2 font-weight-bold grey--text text--lighten-1"
              >
                {{ $vuetify.lang.t("$vuetify.TECNOLOGIA") }}:</span
              >
            </v-row>
            <v-row md="2">
              <EditableComboBox
                :items="techs"
                :event="setTech"
                :rules="[
                  (v) => !!v || $vuetify.lang.t('$vuetify.CAMPO_OBRIGATORIO'),
                ]"
              >
              </EditableComboBox>
            </v-row>
          </v-col>

          <v-col cols="3" class="">
            <v-row>
              <span
                class="text-right subtitle-2 font-weight-bold grey--text text--lighten-1"
              >
                {{ "Cód. empresa de campo" }}:</span
              >
            </v-row>
            <v-row md="2">
              <v-text-field
                v-model.trim="lnb.codigoEmpresaCampo"
                dense
                single-line
                solo
                max-width="200"
                :rules="rules"
              ></v-text-field>
            </v-row>
          </v-col>
        </v-row>
      </v-form>

      <v-divider></v-divider>

      <v-card-actions>
        <v-lazy :options="{ threshold: 0.6 }" transition="slide-x-transition">
          <span class="ml-4 caption red--text" v-show="showLnbAlreadyExists">{{
            $vuetify.lang.t("$vuetify.JA_EXISTE_LNB")
          }}</span>
        </v-lazy>

        <v-spacer></v-spacer>
        <v-btn
          color="blue darken-2"
          text
          @click="
            $refs.form.resetValidation();
            $refs.form.reset();
            close();
          "
        >
          {{ $vuetify.lang.t("$vuetify.CANCELAR") }}
        </v-btn>
        <v-btn
          color="blue darken-2"
          text
          @click="
            $refs.form.validate();
            send(lnb);
          "
          :loading="isLoading"
        >
          {{ $vuetify.lang.t("$vuetify.ENVIAR") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import EditableComboBox from "../../components/fields/EditableComboBox";
export default {
  components: {
    EditableComboBox,
  },
  props: {
    close: Function,
    dialog: Boolean,
    color: String,
    send: Function,
    lnb: Object,
    isLoading: Boolean,
    showLnbAlreadyExists: Boolean,
  },
  methods: {
    setTech(tech) {
      this.lnb.tecnologia = tech;
    },
    getTechs() {
      if (!this.techs) {
        this.$get("/reparo/equipamentos").then((response) => {
          this.techs = response.data.map((e) => {
            return { text: e.tecnologia };
          });
          this.techs.unshift({
            text: "Novo",
          });
          this.techs.unshift({
            header: this.$vuetify.lang.t("$vuetify.SELECIONE_OPCAO"),
          });
        });
      }
    },
    clear() {
      this.techs = undefined;
      this.getTechs();
    },
  },
  data() {
    return {
      rules: [
        (v) =>
          (v && v.trim().length >= 1) ||
          this.$vuetify.lang.t("$vuetify.CAMPO_OBRIGATORIO"),
      ],
    };
  },
  created: function () {
    this.$root.$on("invalidateFields", () => {
      this.$refs.form.resetValidation();
      this.$refs.form.reset();
    });

    this.getTechs();
  },
};
</script>